"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _classnames = _interopRequireDefault(require("classnames"));

var _pillClass;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.members-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .members-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .members-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n  .members-header-class .header-class .margin-top-10 {\n    margin-top: 0.625rem; }\n\n.members-header-class .approval-loader-container {\n  display: flex;\n  justify-content: center; }\n\n.members-header-class .members-tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 0.625rem;\n  max-height: 7.5rem;\n  overflow-y: auto;\n  min-height: 1.25rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .members-header-class .members-tag-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .members-header-class .members-tag-container .view-member-pills-container {\n    display: inline-block;\n    margin-bottom: 0.5rem;\n    margin-right: 1rem; }\n";
  var fileName = "compone_Members";
  var element = document.querySelector("style[data-sass-component='compone_Members']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var pillClass = (_pillClass = {}, _defineProperty(_pillClass, _constants.classes.marginTop10, true), _defineProperty(_pillClass, _constants.classes.tagsContainer, true), _pillClass);

var Member = function Member(_ref) {
  var label = _ref.label,
      entities = _ref.entities,
      translatedStrings = _ref.translatedStrings,
      allEntitiesLabel = _ref.allEntitiesLabel;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", label, " "), (0, _lodash.isEmpty)(entities) ? /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.noneText)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, pillClass))
  }, entities === null || entities === void 0 ? void 0 : entities.map(function (entity, idx) {
    return entity && /*#__PURE__*/_react.default.createElement("div", {
      key: entity.name || idx,
      className: _constants.classes.viewMembersPillContainer
    }, /*#__PURE__*/_react.default.createElement(_pill.default, {
      readOnly: true,
      label: entity === '*' ? allEntitiesLabel : entity.status.toLowerCase() === _constants.inactiveStatus ? "".concat(entity.name, " (").concat(translatedStrings.inactiveText, ")") : entity.name
    }));
  })));
};

Member.propTypes = {
  label: _propTypes.default.string,
  allEntitiesLabel: _propTypes.default.string,
  entities: _propTypes.default.array,
  translatedStrings: _propTypes.default.object
};
var _default = Member;
exports.default = _default;